require("./hero.scss");
/////
// This class is instantiated from page-assets.js
// The initVideo is called after each page content ajax request
////


export class Hero {
	removeContent = (el) => {
		if (!el)
			return;

		while (el.firstChild) el.removeChild(el.firstChild);
	};

	removeLoading = (placeHolder, loadingCircle) => {
		window.setTimeout(() => {
			placeHolder.classList.remove('loading');
			loadingCircle.classList.remove('in');
		}, 1000)
	}

	insertVideo = (placeHolder, videoUrl) => {
		var loadingCircle = document.querySelector('[data-role="loading-circle"]');
		var video = document.createElement('video');

		loadingCircle.classList.add('in');
		video.controls = false;
		video.muted = true;
		video.autoplay = true;
		video.loop = true;
		video.setAttribute('playsinline', 'playsinline');

		placeHolder.appendChild(video);

		if (Hls.isSupported()) {
			var hls = new Hls();
			hls.config.capLevelToPlayerSize = true;
			hls.loadSource(videoUrl);
			hls.attachMedia(video);
			hls.on(Hls.Events.MANIFEST_PARSED, () => {
				video.play();
				this.removeLoading(placeHolder, loadingCircle);
			});

			return;
		} 

		video.src = videoUrl;
		this.removeLoading(placeHolder, loadingCircle);
	};

	initVideo = () => {
		this.isMobile = window.matchMedia("(max-width: 991px)").matches;

		document.querySelector('[data-role="hero"]').setAttribute('data-currentDisplay', this.isMobile);

		document.querySelectorAll('[data-role="hero-media"]').forEach(x => {
			x.classList.add('loading');
			this.removeContent(x);
			let videoUrl = x.getAttribute('data-videoUrl');
			if (videoUrl) {
				let type = x.getAttribute('data-type');
				if (type === 'mobile' && this.isMobile || type === 'desktop' && !this.isMobile)
					this.insertVideo(x, videoUrl);

				return;
			}

			x.classList.remove('loading');
		});
	};

	onResize = () => {
		this.isMobile = window.matchMedia("(max-width: 991px)").matches;

		let currentDisplay = JSON.parse(document.querySelector('[data-role="hero"]').getAttribute('data-currentDisplay'));

		if (this.isMobile === currentDisplay)
			return;
		this.initVideo();
	};

}